module.exports = __webpack_public_path__ + "img/sms-tracking.47cc3522.svg";